import { render, staticRenderFns } from "./ProfileMisDatos.vue?vue&type=template&id=2b67ef2e"
import script from "./ProfileMisDatos.vue?vue&type=script&lang=js"
export * from "./ProfileMisDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports